import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IUserNetwork } from "types/api/addonsApiInterface";
import { ILocations, IOsDetails, IServerTypes } from "types/api/serversApiInterface";

import Continuity from "../Continuity";

import Backup from "./Backup";
import Country from "./Country";
import IpvServer from "./IpvServer";
import ServerSize from "./ServerSize";
import TypeAndOs from "./TypeAndOs";

const HetznerServerCreation = ({
 stepLoading,
 sizeLoading,
 locationList,
 networkList,
 osList,
 typesList,
 serverType,
 os,
 location,
 serverSize,
 enableIpv4,
 enableIpv6,
 enableBackup,
 enableContinuity,
 mailboxProNumber,
 network,
 resetData,
 handleOpen,
 setData
}: {
 stepLoading: boolean;
 sizeLoading: boolean;
 locationList: Array<ILocations>;
 networkList: Array<IUserNetwork>;
 osList: Array<IOsDetails>;
 typesList: Array<IServerTypes>;
 serverType: string;
 os: number;
 location: number;
 serverSize: number;
 enableIpv4: boolean;
 enableIpv6: boolean;
 enableBackup: boolean;
 enableContinuity: boolean;
 mailboxProNumber: number;
 network: number;
 resetData: () => void;
 handleOpen: () => void;
 setData: (section: string, value: string | number | boolean | IServerTypes | ILocations) => void;
}): ReactElement => {
 const checkDisableNext = (): boolean => {
  return (
   serverType === "" ||
   (serverType === "container-mail-pro" && mailboxProNumber < 5) ||
   location === 0 ||
   serverSize === 0 ||
   !enableIpv4 ||
   os === 0 ||
   (serverType === "nfs-server" && network === 0)
  );
 };

 return !stepLoading ? (
  <Stack mt={2} spacing={2}>
   <TypeAndOs
    description="server.add.selectServerTypeMessage"
    osList={osList}
    networkList={networkList}
    os={os}
    mailboxProNumber={mailboxProNumber}
    network={network}
    serverType={serverType}
    setData={(section, data) => setData(section, data)}
   />
   <Country
    description="server.add.selectLocationMessage"
    location={location}
    locationList={locationList}
    setData={(section, data) => setData(section, data)}
   />
   <ServerSize
    description="server.add.selectTypeMessage"
    typesList={typesList}
    serverSize={serverSize}
    sizeLoading={sizeLoading}
    setData={(section, data) => setData(section, data)}
   />
   <IpvServer
    description="server.add.enableIpMessage"
    enableIpv4={enableIpv4}
    enableIpv6={enableIpv6}
    setData={(section, data) => setData(section, data)}
   />
   <Backup
    description="server.add.enableBackupMessage"
    enableBackup={enableBackup}
    setData={(section, data) => setData(section, data)}
   />
   <Continuity
    description="server.add.enableContinuityMessage"
    enableContinuity={enableContinuity}
    enableBackup={enableBackup}
    disableNext={checkDisableNext()}
    resetData={resetData}
    handleOpen={handleOpen}
    setData={(section, data) => setData(section, data)}
   />
  </Stack>
 ) : (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left", mt: 2 }}>
   <Stack spacing={2} direction="row" alignItems="center">
    <Typography variant="subtitle2">
     <FormattedMessage id="server.checkExecution" />
    </Typography>
    <CircularProgress />
   </Stack>
  </Paper>
 );
};

export default HetznerServerCreation;
